t = require('views/internal/teacup-with-helpers')('boards_page_add_org_button')

module.exports = ->
  t.div '.boards-page-board-section.u-clearfix', ->
    t.a '.quiet-button.u-float-left.js-add-org-boards-page', { href: '#' }, ->
      t.format 'create-a-new-organization-ellipsis'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/boards_page_add_org_button.coffee